module.exports = __webpack_public_path__ + "media/images/facil-icon-f660b81debd8ded9a1e8e45fa3762b63.png";